import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";

export function CallbackPage() {
  const navigate = useNavigate();
  const { refresh, status, identity } = useAuth();
  useEffect(() => {
    void refresh();
  }, [refresh]);
  useEffect(() => {
    if (status === "signed_in" && identity)
      navigate("/overview", { replace: true });
    if (status === "signed_out") navigate("/login", { replace: true });
  }, [status, identity, navigate]);
  return (
    <div className="flex h-screen items-center justify-center text-muted-foreground">
      Completing sign-in…
    </div>
  );
}
